<template>
  <div class="recruit-title-box">
    <div class="recruit-title">
      <span class="box-shadow"></span
      ><span class="title"
        ><span style="color:#FF0207">{{ icon }}</span
        >{{ title }}</span
      >
    </div>
    <div class="slot">
      <slot name="info"></slot>
    </div>
    <div class="slot-switch">
      <slot name="switch"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.recruit-title-box {
  border-bottom: 1px solid #efefef;
  position: relative;
  margin-top: 10px;
  .recruit-title {
    min-height: 88px;
    display: flex;
    align-items: center;
    background: #fff;
    .box-shadow {
      width: 12px;
      height: 32px;
      background: rgba(54, 196, 144, 1);
      display: inline-block;
      margin-right: 20px;
    }
    .title {
      color: #000;
      font-size: 32px;
      font-family: PingFang S;
    }
  }
  .slot {
    color: #999;
    font-size: 24px;
    line-height: 2;
    padding-left: 32px;
    background: #fff;
  }
  .slot-switch {
    position: absolute;
    right: 34px;
    top: 20px;
  }
}
</style>
